import { atom } from "recoil";

export const loadingWithShadowState = atom({
  key: "loadingWithShadowState",
  default: false,
});
